import { render, staticRenderFns } from "./forty_notes.vue?vue&type=template&id=100deeec&scoped=true"
import script from "./forty_notes.vue?vue&type=script&lang=js"
export * from "./forty_notes.vue?vue&type=script&lang=js"
import style0 from "./forty_notes.vue?vue&type=style&index=0&id=100deeec&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100deeec",
  null
  
)

export default component.exports